import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardContent, CardMedia, Typography, Divider, IconButton, CardActions, Paper, Grid, Box, Tooltip } from '@mui/material';
import { useSnackbar } from 'notistack';
import RoomIcon from '@mui/icons-material/Room';
import FullScreenModal from 'components/FullScreenModal';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddProperty from '../add';
import useConfirm from 'core/hooks/useConfirm';
import { deleteLibraryFromStage, getLibrariesPendingApproval } from 'services/property';

const Approvals = () => {

  const [pendingApprovals, setPendingApprovals] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const confirm = useConfirm();
  const [propertyInfo, setPropertyInfo] = useState({ id: null, isApproved: false });

  useEffect(() => {
    getPendingApprovalList();
  }, []);

  function getPendingApprovalList() {
    getLibrariesPendingApproval().then(({response, error}) => {
      if(response){
        setPendingApprovals([...(response || [])]);
      } else {
        setPendingApprovals([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  const onDeleteProperty = (libraryId) => {
    confirm({ title: 'Delete Library?', description: 'This library will be deleted and this cannot be undone. Are you sure you want to proceed?' })
    .then(() => { 
      deleteProperty(libraryId);
    })
    // .catch(() => { 
      
    // });
  }

  const deleteProperty = (libraryId) => {
    deleteLibraryFromStage({libraryId}).then(({response, error}) => {
      if(response){
        enqueueSnackbar("Library deleted successfully", {variant: 'success'});
        getPendingApprovalList();
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  const onModalClose = useCallback(
    () => {
      getPendingApprovalList();
      setOpenModal(false);
    },
    [setOpenModal],
  )

 
  // const onSuccess = useCallback(
  //   () => {
  //     setOpenModal(false);
  //   },
  //   [setOpenModal],
  // )


  const editPropertyDetails = (propertyId) => {
    setPropertyInfo({ id: propertyId, isApproved: false });
    setOpenModal(true);
  }

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
    {/* <CardContent> */}
      <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        Pending Approvals
      </Typography>
      <Divider />
      <Box noValidate  sx={{ mt: 2 }} >
        <Grid container spacing={3}>
          {pendingApprovals.map((property) => (
            <Grid item xs={12} sm={12} md={6} xl={3} lg={4} key={property.libraryId}>
              <Card sx={{ maxWidth: 345, position: 'relative' }}>
                <CardMedia
                  component="img"
                  height="140"
                  image={`/vendor/rest/properties/images/${property.libraryId}/coverPhoto.jpg`}
                  alt="Cover Photo"
                  sx={{cursor: 'pointer' }}
                  onClick={() => editPropertyDetails(property.libraryId)}
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    {property.name}
                  </Typography>
                  <Tooltip arrow title={`
                    ${property.address.area ? `${property.address.area}, ` : null}
                    ${property.address.city ? `${property.address.city}, ` : null}
                    ${property.address.state ? `${property.address.state}, ` : null}
                    ${property.address.country ? `${property.address.country}` : null}
                    ${property.address.pin ? ` - ${property.address.pin}` : null}
                  `} 
                  placement="top">
                    <Typography component="address" variant="body2" color="text.secondary" sx={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden'}}> 
                      <RoomIcon sx={{verticalAlign: 'bottom'}} />
                      {property.address.area ? `${property.address.area}, ` : null}
                      {property.address.city ? `${property.address.city}, ` : null}
                      {property.address.state ? `${property.address.state}, ` : null}
                      {property.address.country ? `${property.address.country}` : null}
                      {property.address.pin ? ` - ${property.address.pin}` : null}
                    </Typography>
                  </Tooltip>
                </CardContent>
                <CardActions  sx={{ position: 'absolute', top: 110, right: 0}}>
                  <IconButton variant="raised" sx={{
                    borderRadius: '50%', background: '#f3f3f3', color: '#a51414',
                    "&.MuiButtonBase-root:hover": {
                      bgcolor: "#f3f3f3"
                    }
                    }}  onClick={() => onDeleteProperty(property.libraryId)}
                  >
                    <DeleteForeverIcon />
                  </IconButton>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <FullScreenModal open={openModal} onModalClose={onModalClose} title={propertyInfo.id ? 'Update Library' : 'Add Library'}>
        <AddProperty propertyId={propertyInfo.id} isApproved={propertyInfo.isApproved} />
      </FullScreenModal>
    </Paper>
  );
}
 
export default React.memo(Approvals);
